import { create } from 'zustand';
import { FormType } from '../../types';

const INITIAL_FORM_STATE: FormType = {
  name: '',
  note: '',
  statusNote: '',
  compType: null,
  validFrom: '',
  validTo: '',
  confirmDat: '',
  CTStartDate: '',
  CTEndDate: '',
  CTEducationLevel: '',
  CTInstitutionName: '',
  CTAttainedTitle: '',
  CTCourseOrSeminarType: '',
  CTOrganizer: '',
  CTConfirmation: '',
  CTAttendType: '',
  CTLanguageName: '',
  CTLanguageListeningComprehension: 0,
  CTLanguageReadingComprehension: 0,
  CTLanguageSpeakingLevel: 0,
  CTLanguageWritingLevel: 0,
  CTOrganizationTitle: '',
  CTOrganizationLocation: '',
  CTOrganizationWebsite: '',
  CTTasks: '',
  CTStandardActivityClassification: '',
  CTPosition: '',
  CTProjectTitle: '',
  CTRole: '',
  CTCountry: '',
};

type CreatePageState = {
  form: FormType;
  files: File[];
};

type CreatePageActions = {
  setForm: (form: FormType) => void;
  setFiles: (files: File[]) => void;
  reset: () => void;
};

export const useCreatePageStore = create<CreatePageState & CreatePageActions>((set) => ({
  form: { ...INITIAL_FORM_STATE },
  files: [],
  setForm: (form: FormType) => set({ form }),
  setFiles: (files: File[]) => set({ files }),
  reset: () => set({ form: { ...INITIAL_FORM_STATE }, files: [] }),
}));
